export const HOME_PAGE = `/home`
export const SURVEY_PAGE = `/survey`
export const ADMIN_PAGE = `/admin`
export const VERIFY_PAGE = `/verify`
export const LOBBY_PAGE = `/lobby`
export const LOGIN_PAGE = `/login`
export const FINALE_PAGE = `/print`
export const REGISTER_PAGE = `/register`
export const NOT_AUTHORIZED_PAGE = `/not-authorized`
export const INSERT_RELATIVE_PAGE = "/relative"
export const CALL_PAGE = "/call"
export const PAYMENT_PAGE = "/payment"
export const PROFILE_PAGE = "/profile"
export const PROFILE_DOCUMENTS_PAGE = "/profile/documents"
// `location.state.tab` value that opens the Profile page on its "Profil" tab
export const PROFILE_INFORMATIONS_TAB = "INFORMATIONS"
export const VERIFY_PHONE_PAGE = "/verify"
export const STATISTICS_PAGE = "/statistics"
export const RESET_PASSWORD_PAGE = "/reset-password"
export const NIR_AND_EXEMPTION_PAGE = "/nir-and-rights"
export const MODIFY_RELATIVE_PAGE = "/modify-relative"
export const TUTORIALS_PAGE = "/tutorial-video"
export const GET_DOCTOR_PAGE = "/doctors"
export const DOCTOR_CHOICE_PAGE = "/doctor-choice"
export const SEARCH_DOCTOR_PAGE = "/doctor-search"
export const NO_NETWORK_PAGE = "/bad-network"
export const UPLOAD_DOC_PAGE = "/upload"
export const SET_RELATIVE_PAGE = "/set-relative-gender"
export const COMPLETE_PATIENT_INFO_PAGE = "/complete-patient-info"
export const CONSENT_PAGE = "/consent"
export const ADMIN_CARERS_PAGE = "/carers"
export const VITALS_PAGE = "/vitals"
export const MAINTENANCE_PAGE = "/maintenance"
export const DIAGNOSTIC_DEVICES_PAGE = "/diagnostic-devices"
export const DOCUMENT_NOT_FOUND_PAGE = "/document-not-found"
export const DERMATOSCOPE_VIDEO_PAGE = "/video/dermatoscope"
export const DERMATO_RECAP_PAGE = "/teleexpertise/recap"
export const PATCH_PAGE = "/patch"
export const TELEEXPERTISE_CONSENT_PAGE = "/teleexpertise/consent"
export const TELEEXPERTISE_END_PAGE = "/teleexpertise/end"
export const PREVENTION_REPORT_INFO = '/prevention-report-info'
export const PHARMACIST_END_PAGE = '/prevention/pharmacist-end'
export const PHARMACIST_EMAIL_PAGE = '/prevention/pharmacist-email'
export const READERS_CONFIGURATION_PAGE = '/readers/configuration'
export const CHECKUP_REPORT_PAGE = '/checkup/report'
export const CHECKUP_END_PAGE = '/checkup/print'
export const DERMATO_PHARMACIST_INFO_PAGE = '/teleexpertise/pharmacist-info'
